module.exports = __webpack_public_path__ + "img/FLSH4.bc84d3b6.svg";